import { Flex } from "@chakra-ui/react";
import { VersionTag } from "../elements/VersionTag";

export function AppFooter() {
  return (
    <Flex
      bg="brand.gray.90"
      color="brand.red.100"
      gap={4}
      justifyContent="flex-end"
      mt="auto"
      px={4}
      py={2}
      verticalAlign="baseline"
      w="100%"
    >
      <VersionTag />
    </Flex>
  );
}
